var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandingPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:sparkles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NCOB-Settings-Quick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC-OB-Branding",
    transform: "translate(-66.5, -279.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:sparkles",
    transform: "translate(65, 278)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.813,15.904 L9,18.75 L8.187,15.904 C7.75980789,14.4094508 6.59154924,13.2411921 5.097,12.814 L2.25,12 L5.096,11.187 C6.59054924,10.7598079 7.75880789,9.59154924 8.186,8.097 L9,5.25 L9.813,8.096 C10.2401921,9.59054924 11.4084508,10.7588079 12.903,11.186 L15.75,12 L12.904,12.813 C11.4094508,13.2401921 10.2411921,14.4084508 9.814,15.903 L9.813,15.904 Z M18.259,8.715 L18,9.75 L17.741,8.715 C17.4389168,7.50583806 16.4950388,6.56157565 15.286,6.259 L14.25,6 L15.286,5.741 C16.4950388,5.43842435 17.4389168,4.49416194 17.741,3.285 L18,2.25 L18.259,3.285 C18.5612535,4.49442443 19.5055756,5.4387465 20.715,5.741 L21.75,6 L20.715,6.259 C19.5055756,6.5612535 18.5612535,7.50557557 18.259,8.715 Z M16.894,20.567 L16.5,21.75 L16.106,20.567 C15.8820448,19.8951539 15.3548461,19.3679552 14.683,19.144 L13.5,18.75 L14.683,18.356 C15.3548461,18.1320448 15.8820448,17.6048461 16.106,16.933 L16.5,15.75 L16.894,16.933 C17.1179552,17.6048461 17.6451539,18.1320448 18.317,18.356 L19.5,18.75 L18.317,19.144 C17.6451539,19.3679552 17.1179552,19.8951539 16.894,20.567 L16.894,20.567 Z",
    id: "Shape",
    stroke: "#8E06BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingPurple);
export default __webpack_public_path__ + "static/media/Branding-purple.9e5af0c1b42cb56859a95c0dc63c7caf.svg";
export { ForwardRef as ReactComponent };